
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/toplists/[id]",
      function () {
        return require("private-next-pages/airlines/toplists/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/toplists/[id]"])
      });
    }
  